import ApiService from '@/services/core/api.service'

const HistoryService = {
  async get (query = '') {
    return ApiService.get(`user/reports/payment-requests?${query}`)
  },

  async post (payload) {
    return ApiService.post('user/reports/payment-requests', payload)
  },

  async put (payload) {
    return ApiService.put(`user/reports/payment-requests/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`user/reports/payment-requests/${payload.id}`)
  }
}

export default HistoryService
